<template>
  <el-dropdown trigger="click" class='international' @command="handleSetLanguage">
    <span class="el-dropdown-link">
      语言选择<i class="el-icon-arrow-down el-icon--right"></i>
    </span>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item command="zh" :disabled="language==='zh'">简体中文</el-dropdown-item>
      <el-dropdown-item command="zhtw" :disabled="language==='zhtw'">繁体中文</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters([
      'language'
    ])
  },
  methods: {
    handleSetLanguage(lang) {
      this.$i18n.locale = lang
      this.$store.commit('SET_LANGUAGE', lang);
      this.$message({
        message: 'switch language success',
        type: 'success'
      })
    }
  }
}
</script>

<style scoped>
.international-icon {
  font-size: 20px;
  cursor: pointer;
  vertical-align: -5px!important;
}
</style>





// WEBPACK FOOTER //
// src/components/langSelect/index.vue